<template>
  <svg :width="size" :height="size" viewBox="0 0 10 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M8 10.8571V9.71429C8 9.25963 7.81926 8.82372 7.49777 8.50223C7.17628 8.18074 6.74037 8 6.28571 8H2.85714C2.40249 8 1.96658 8.18074 1.64509 8.50223C1.3236 8.82372 1.14286 9.25963 1.14286 9.71429V10.8571C1.14286 11.1727 0.88702 11.4286 0.571429 11.4286C0.255837 11.4286 0 11.1727 0 10.8571V9.71429C0 8.95652 0.301235 8.23001 0.837054 7.6942C1.37287 7.15838 2.09938 6.85714 2.85714 6.85714H6.28571C7.04348 6.85714 7.76999 7.15838 8.3058 7.6942C8.84162 8.23001 9.14286 8.95652 9.14286 9.71429V10.8571C9.14286 11.1727 8.88702 11.4286 8.57143 11.4286C8.25584 11.4286 8 11.1727 8 10.8571ZM6.28571 2.85714C6.28571 1.91037 5.5182 1.14286 4.57143 1.14286C3.62465 1.14286 2.85714 1.91037 2.85714 2.85714C2.85714 3.80392 3.62465 4.57143 4.57143 4.57143C5.5182 4.57143 6.28571 3.80392 6.28571 2.85714ZM7.42857 2.85714C7.42857 4.4351 6.14939 5.71429 4.57143 5.71429C2.99347 5.71429 1.71429 4.4351 1.71429 2.85714C1.71429 1.27919 2.99347 0 4.57143 0C6.14938 0 7.42857 1.27919 7.42857 2.85714Z"
      :fill="fill" />
  </svg>
</template>

<script>
export default {
  name: 'UserIcon',
  props: {
    size: {
      type: [Number, String],
      default: 16,
    },
    fill: {
      type: String,
      default: '#8A8D93',
    },
  },
};
</script>